export default {
  getStaffCompany () {
    this.$http.get('/v1/search/professionals/professionals')
        .then(({data}) => {
          this.optionsComapnyStaff = data
        })
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/form/resources/methods.js